export function getVersionAwareUploadFailureMessage({
  failedCount,
  uploadedCount,
}: {
  failedCount: number;
  uploadedCount: number;
}) {
  if (!failedCount) return undefined;
  if (!uploadedCount) return 'File upload failed. Please try again.';
  return `Only ${uploadedCount} of ${uploadedCount + failedCount} files were saved. Please try the rest again.`;
}
